import {FilterColorInterface} from "../../../../interfaces/catalog/FilterColorInterface";
import SimpleBar from 'simplebar-react';
import {useState} from "react";

interface ColorFiltersProps {
    selectedColors: FilterColorInterface[];
    getUniqueColors: () => FilterColorInterface[];
    addColor: (color: FilterColorInterface) => void;
    removeColor: (color: FilterColorInterface) => void;
}

export default function ColorFilters({
    selectedColors,
    getUniqueColors,
    addColor,
    removeColor
}: ColorFiltersProps) {
    const [isFolderActive, setIsFolderActive] = useState<boolean>(false);

    const isColorActive = (inColor: FilterColorInterface) => {
        return selectedColors?.map(color => color.color).includes(inColor.color)
    }

    return (
        <>
            <div className="all-filters-block">
                <div className="all-filters__accord">
                    <p className={"all-filters__title all-filters__link f-exp " + (isFolderActive && 'active')}
                       onClick={() => {
                           setIsFolderActive(!isFolderActive)
                       }}>Цвет <i
                        className="ico ico-arrow-bot-b" onClick={() => {
                        setIsFolderActive(!isFolderActive)
                    }}></i></p>
                    {isFolderActive && <div className="all-filters__col">
                        <div className="all-filters__height">
                            <SimpleBar style={{maxHeight: 230}} autoHide={false}>
                                <div className="scrollbar-inner">
                                    <ul className="filters__collapse-checkboxes">
                                        {getUniqueColors().map(color => <li key={color.color}>
                                            <div
                                                className={"form-checkbox " + (isColorActive(color) && "active")}
                                                onClick={() => isColorActive(color) ? removeColor(color) : addColor(color)}>
                                                <label className={"label-dot"}></label>
                                                <label className="label-text"><i
                                                    style={{background: color.hex}}></i>{color.color}</label>
                                            </div>
                                        </li>)}
                                    </ul>
                                </div>
                            </SimpleBar>
                        </div>
                    </div>}
                </div>
            </div>
            <ul className="all-filters__activated">
                {selectedColors.map((color) => <li key={color.color}><a className="ico-cont" href="/"><i
                    className="color" style={{background: color.hex}}></i><i
                    className="ico ico-right ico-delete"
                    onClick={(event) => {
                        event.preventDefault()
                        removeColor(color)
                    }}></i></a></li>)}
            </ul>
        </>
    );
}